import { Country } from '~/types/countries'
import { ApiKy } from './index'

export default class Api extends ApiKy {
  get() {
    return this.ky.get(`${this.url}`)?.json<Country[]>()
  }
}
